
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./app/javascript/marketing.ts";
              export default OriginalModule.default;
              export * from "./app/javascript/marketing.ts";